<template>
  <div>
    <!-- Sidebar -->
    <v-navigation-drawer
      app
      v-model="drawer"
      class="sidebar dont-print-header"
      width="272"
    >
      <!-- Logo / Brand -->
      <div class="sidebar-brand">
        <div class="sidebar-brand-logo">
          <v-img
            :src="company.logo_path ? `${mediaUrl + company.logo_path}` : require('../../assets/BusinessPe.png')"
            contain
            width="32"
            height="32"
            class="brand-img"
          />
        </div>
        <div class="sidebar-brand-text">
          <span class="brand-name">BusinessPe</span>
          <span class="brand-sub">Admin Portal</span>
        </div>
      </div>

      <v-divider class="sidebar-divider" />

      <!-- Navigation -->
      <div class="sidebar-nav">

        <!-- OVERVIEW -->
        <div class="nav-section">
          <span class="nav-section-label">Overview</span>
          <router-link to="/home" class="nav-item" :class="{ 'nav-item--active': $route.path === '/home' }">
            <v-icon class="nav-icon" size="18">mdi-view-dashboard-outline</v-icon>
            <span class="nav-label">Dashboard</span>
          </router-link>
        </div>

        <!-- COMPANIES (Super Admin only) -->
        <div
          class="nav-section"
          v-if="roleName == 'SUPER ADMIN' && company.id == null"
        >
          <span class="nav-section-label">Management</span>
          <router-link to="/companies" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/companies') }">
            <v-icon class="nav-icon" size="18">mdi-office-building-outline</v-icon>
            <span class="nav-label">Companies</span>
          </router-link>
        </div>

        <!-- USERS -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">Users</span>
          <router-link to="/users" exact class="nav-item" :class="{ 'nav-item--active': $route.path === '/users' }">
            <v-icon class="nav-icon" size="18">mdi-account-multiple-outline</v-icon>
            <span class="nav-label">All Users</span>
          </router-link>
          <router-link to="/referral-users" class="nav-item" :class="{ 'nav-item--active': $route.path === '/referral-users' }">
            <v-icon class="nav-icon" size="18">mdi-account-network-outline</v-icon>
            <span class="nav-label">Referral Users</span>
          </router-link>
          <router-link to="/users/withdrawal-status" class="nav-item" :class="{ 'nav-item--active': $route.path === '/users/withdrawal-status' }">
            <v-icon class="nav-icon" size="18">mdi-cash-refund</v-icon>
            <span class="nav-label">Withdrawal Status</span>
          </router-link>
          <router-link to="/users/deposit-status" class="nav-item" :class="{ 'nav-item--active': $route.path === '/users/deposit-status' }">
            <v-icon class="nav-icon" size="18">mdi-cash-plus</v-icon>
            <span class="nav-label">Deposit Status</span>
          </router-link>
          <router-link to="/bank_details" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/bank_details') }">
            <v-icon class="nav-icon" size="18">mdi-bank-outline</v-icon>
            <span class="nav-label">Bank Details</span>
          </router-link>
        </div>

        <!-- PRODUCTS -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">Products</span>
          <router-link to="/product-types" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/product-types') }">
            <v-icon class="nav-icon" size="18">mdi-shape-outline</v-icon>
            <span class="nav-label">Product Types</span>
          </router-link>
          <router-link to="/products" class="nav-item" :class="{ 'nav-item--active': $route.path === '/products' || $route.path.startsWith('/products/') }">
            <v-icon class="nav-icon" size="18">mdi-package-variant-closed</v-icon>
            <span class="nav-label">Products</span>
          </router-link>
          <router-link to="/categories" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/categories') }">
            <v-icon class="nav-icon" size="18">mdi-tag-multiple-outline</v-icon>
            <span class="nav-label">Categories</span>
          </router-link>
          <router-link to="/product_enquiries" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/product_enquiries') }">
            <v-icon class="nav-icon" size="18">mdi-help-circle-outline</v-icon>
            <span class="nav-label">Product Enquiries</span>
          </router-link>
        </div>

        <!-- INVESTMENTS -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">Investments</span>
          <router-link to="/investments" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/investments') }">
            <v-icon class="nav-icon" size="18">mdi-chart-line</v-icon>
            <span class="nav-label">Investments</span>
          </router-link>
        </div>

        <!-- RMC -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">RMC Plants</span>
          <router-link to="/rmc-plants" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-plants') }">
            <v-icon class="nav-icon" size="18">mdi-office-building-cog-outline</v-icon>
            <span class="nav-label">Plants</span>
          </router-link>
          <router-link to="/rmc-bookings" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-bookings') }">
            <v-icon class="nav-icon" size="18">mdi-bookmark-multiple-outline</v-icon>
            <span class="nav-label">Bookings</span>
          </router-link>
          <router-link to="/rmc-orders" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-orders') }">
            <v-icon class="nav-icon" size="18">mdi-truck-delivery-outline</v-icon>
            <span class="nav-label">Material Orders</span>
          </router-link>
          <router-link to="/rmc-marketplace" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-marketplace') }">
            <v-icon class="nav-icon" size="18">mdi-store-outline</v-icon>
            <span class="nav-label">Marketplace</span>
          </router-link>
          <router-link to="/rmc-deliveries" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-deliveries') }">
            <v-icon class="nav-icon" size="18">mdi-truck-fast-outline</v-icon>
            <span class="nav-label">Deliveries</span>
          </router-link>
          <router-link to="/rmc-plans" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-plans') }">
            <v-icon class="nav-icon" size="18">mdi-layers-triple-outline</v-icon>
            <span class="nav-label">Membership Plans</span>
          </router-link>
          <router-link to="/rmc-subscriptions" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/rmc-subscriptions') }">
            <v-icon class="nav-icon" size="18">mdi-account-star-outline</v-icon>
            <span class="nav-label">Plan Subscribers</span>
          </router-link>
        </div>

        <!-- SUPPORT -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">Support</span>
          <router-link to="/tickets" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/tickets') }">
            <v-icon class="nav-icon" size="18">mdi-ticket-outline</v-icon>
            <span class="nav-label">Tickets</span>
          </router-link>
          <router-link to="/values" class="nav-item" :class="{ 'nav-item--active': $route.path.startsWith('/values') }">
            <v-icon class="nav-icon" size="18">mdi-numeric</v-icon>
            <span class="nav-label">Values</span>
          </router-link>
        </div>

        <!-- COMPANY SETTINGS -->
        <div
          class="nav-section"
          v-if="roleName == 'ADMIN' || (roleName == 'SUPER ADMIN' && company.id != null)"
        >
          <span class="nav-section-label">Company Settings</span>
          <router-link to="/about-us" class="nav-item" :class="{ 'nav-item--active': $route.path === '/about-us' }">
            <v-icon class="nav-icon" size="18">mdi-information-outline</v-icon>
            <span class="nav-label">About Us</span>
          </router-link>
          <router-link to="/contact-us" class="nav-item" :class="{ 'nav-item--active': $route.path === '/contact-us' }">
            <v-icon class="nav-icon" size="18">mdi-phone-outline</v-icon>
            <span class="nav-label">Contact Us</span>
          </router-link>
          <router-link to="/terms-conditions" class="nav-item" :class="{ 'nav-item--active': $route.path === '/terms-conditions' }">
            <v-icon class="nav-icon" size="18">mdi-file-document-outline</v-icon>
            <span class="nav-label">Terms &amp; Conditions</span>
          </router-link>
          <router-link to="/privacy-policies" class="nav-item" :class="{ 'nav-item--active': $route.path === '/privacy-policies' }">
            <v-icon class="nav-icon" size="18">mdi-shield-check-outline</v-icon>
            <span class="nav-label">Privacy Policy</span>
          </router-link>
          <router-link to="/company-bank-detail" class="nav-item" :class="{ 'nav-item--active': $route.path === '/company-bank-detail' }">
            <v-icon class="nav-icon" size="18">mdi-bank-outline</v-icon>
            <span class="nav-label">Bank Detail</span>
          </router-link>
        </div>

      </div>

      <!-- User Profile Footer -->
      <template v-slot:append>
        <v-divider class="sidebar-divider" />
        <div class="sidebar-user">
          <div class="user-avatar">
            {{ userInitials }}
          </div>
          <div class="user-info">
            <span class="user-name">{{ user.user_name || user.email }}</span>
            <span class="user-role">
              {{ roleName == 'SUPER ADMIN' && company.id != null ? 'ADMIN' : roleName }}
            </span>
          </div>
          <v-btn
            icon
            small
            title="Logout"
            class="logout-btn"
            @click="logout"
          >
            <v-icon size="18">mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Top App Bar -->
    <v-app-bar
      app
      color="white"
      flat
      class="topbar dont-print-header"
      height="64"
      style="border-bottom: 1px solid #e2e8f0;"
    >
      <!-- Mobile menu toggle -->
      <v-btn icon @click.stop="drawer = !drawer" class="topbar-menu-btn">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <!-- Breadcrumb / Page title -->
      <div class="topbar-title d-none d-sm-flex align-center">
        <router-link to="/home" class="topbar-home-link">
          <v-icon size="16" color="#94a3b8">mdi-home-outline</v-icon>
        </router-link>
        <v-icon size="14" color="#94a3b8" class="mx-1">mdi-chevron-right</v-icon>
        <span class="topbar-page-name">{{ currentPageName }}</span>
      </div>

      <v-spacer />

      <!-- Super Admin Switch -->
      <div v-if="roleName == 'SUPER ADMIN'" class="topbar-switch">
        <v-switch
          inset
          dense
          hide-details
          @change="switch_to(company.id)"
          :loading="isSwitching"
          v-model="is_acting_admin"
          :label="is_acting_admin ? 'Admin' : 'Super Admin'"
          color="primary"
          class="mt-0 pt-0"
        />
      </div>

      <!-- Company name chip -->
      <v-chip
        v-if="company.name"
        small
        outlined
        color="primary"
        class="mx-2 d-none d-md-flex"
      >
        <v-icon left x-small>mdi-office-building-outline</v-icon>
        {{ company.name }}
      </v-chip>

      <!-- Profile menu -->
      <v-menu offset-y left nudge-bottom="8" rounded="lg">
        <template v-slot:activator="{ on, attrs }">
          <div class="topbar-avatar" v-bind="attrs" v-on="on">
            <div class="topbar-avatar-circle">
              {{ userInitials }}
            </div>
            <div class="topbar-avatar-info d-none d-md-block">
              <span class="topbar-user-name">{{ user.user_name || user.email }}</span>
              <span class="topbar-user-role">{{ roleName == 'SUPER ADMIN' && company.id != null ? 'Admin' : roleName }}</span>
            </div>
          </div>
        </template>
        <v-list dense class="profile-menu" min-width="200">
          <div class="profile-menu-header">
            <p class="profile-menu-name">{{ user.user_name || user.email }}</p>
            <p class="profile-menu-email">{{ user.email }}</p>
          </div>
          <v-divider />
          <v-list-item :to="`/profile/${encryptIt(user.id)}`" class="profile-menu-item">
            <v-icon small class="mr-2" color="#64748b">mdi-account-outline</v-icon>
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="logout" class="profile-menu-item logout-item">
            <v-icon small class="mr-2" color="#ef4444">mdi-logout</v-icon>
            <v-list-item-title style="color: #ef4444;">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Page Content -->
    <v-main class="main-content">
      <router-view />
    </v-main>

    <!-- Company Switch Dialog -->
    <v-dialog v-model="show_company_dialog" max-width="800" scrollable>
      <v-card rounded="lg">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-account-switch-outline</v-icon>
          Switch to Admin
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Select the company admin portal you'd like to switch to.
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="form.search_keyword"
            outlined
            dense
            label="Search companies..."
            clearable
            prepend-inner-icon="mdi-magnify"
            @click:clear="(form.search_keyword = null), getCompanies()"
            @keydown.enter="getCompanies"
            @change="page = 1"
            class="modern-field"
            hide-details
          />
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
            class="mt-3"
          />
          <div v-else class="mt-3">
            <v-simple-table fixed-header height="300" class="striped-table rounded-lg">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Company</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Admin</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="companies.length">
                  <tr
                    v-for="(company, i) in companies"
                    :key="`company_${i}`"
                    :class="{ 'table-row-even': i % 2 === 0, 'table-row-odd': i % 2 !== 0 }"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <v-chip x-small :color="company.is_active == 1 ? 'success' : 'error'" text-color="white">
                        {{ company.is_active == 1 ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </td>
                    <td>
                      <div class="d-flex align-center gap-2">
                        <v-avatar size="28" rounded>
                          <v-img
                            :src="company.logo_path ? `${mediaUrl + company.logo_path}` : require('../../assets/BusinessPe.png')"
                            contain
                          />
                        </v-avatar>
                        <span>{{ company.name }}</span>
                      </div>
                    </td>
                    <td>{{ company.email }}</td>
                    <td>{{ company.admin_name }}</td>
                    <td class="text-right">
                      <v-btn x-small depressed color="primary" rounded @click="changeCompany(company.id)">
                        <v-icon x-small left>mdi-account-switch-outline</v-icon>
                        Switch
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center py-6 grey--text">No companies found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn text @click="show_company_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";
import axios from "axios";
import store from "@/store";

const PAGE_NAMES = {
  "/home": "Dashboard",
  "/companies": "Companies",
  "/users": "Users",
  "/referral-users": "Referral Users",
  "/users/withdrawal-status": "Withdrawal Status",
  "/users/deposit-status": "Deposit Status",
  "/bank_details": "Bank Details",
  "/product-types": "Product Types",
  "/products": "Products",
  "/categories": "Categories",
  "/product_enquiries": "Product Enquiries",
  "/investments": "Investments",
  "/rmc-plants": "RMC Plants",
  "/rmc-bookings": "RMC Bookings",
  "/rmc-orders": "Material Orders",
  "/rmc-marketplace": "Marketplace",
  "/rmc-deliveries": "Deliveries",
  "/rmc-plans": "Membership Plans",
  "/rmc-subscriptions": "Plan Subscribers",
  "/tickets": "Tickets",
  "/values": "Values",
  "/about-us": "About Us",
  "/contact-us": "Contact Us",
  "/terms-conditions": "Terms & Conditions",
  "/privacy-policies": "Privacy Policy",
  "/company-bank-detail": "Company Bank Detail",
};

export default {
  data() {
    return {
      form: { search_keyword: "" },
      drawer: true,
      is_acting_admin: false,
      selectedCompanyId: "",
      companies: [],
      isLoading: false,
      isSwitching: false,
      show_company_dialog: false,
      hide_bell: false,
    };
  },
  computed: {
    userInitials() {
      const name = this.user.user_name || this.user.email || "";
      return name
        .split(" ")
        .slice(0, 2)
        .map((n) => n[0])
        .join("")
        .toUpperCase();
    },
    currentPageName() {
      const path = this.$route.path;
      if (PAGE_NAMES[path]) return PAGE_NAMES[path];
      for (const key of Object.keys(PAGE_NAMES)) {
        if (path.startsWith(key + "/")) return PAGE_NAMES[key];
      }
      return "";
    },
  },
  mounted() {
    let company = store.getters["auth/company"];
    if (Object.keys(company).length > 0) {
      this.selectedCompanyId = company.id;
      if (this.roleName == "SUPER ADMIN") {
        this.is_acting_admin = true;
      }
    }
  },
  methods: {
    ...mapActions({ logOut: "auth/logOut" }),
    logout() {
      this.logOut();
      location.replace("/");
    },
    async getCompanies() {
      this.isLoading = true;
      const q = `search_keyword=${this.form.search_keyword || ""}&is_active=${this.form.is_active || ""}`;
      const res = await axios.get(`companies?${q}`);
      this.companies = res.data.data;
      this.isLoading = false;
    },
    changeCompany(companyId) {
      this.selectedCompanyId = companyId;
      const company = this.companies.find((c) => c.id == companyId);
      store.dispatch("auth/setCompany", company || "");
      window.location.href = "/auth/login";
      this.isSwitching = false;
      this.show_company_dialog = false;
    },
    switch_to() {
      this.isSwitching = true;
      if (this.is_acting_admin) {
        this.show_company_dialog = true;
      } else {
        this.selectedCompanyId = null;
        this.changeCompany();
      }
    },
  },
};
</script>

<style scoped>
/* ── Sidebar ── */
.sidebar {
  background: #fff !important;
  border-right: 1px solid #e2e8f0 !important;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  height: 64px;
}

.sidebar-brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1A3A6B, #152E56);
  flex-shrink: 0;
  overflow: hidden;
  padding: 4px;
}

.brand-img {
  border-radius: 6px;
}

.sidebar-brand-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.brand-name {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.brand-sub {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sidebar-divider {
  border-color: #f1f5f9 !important;
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  padding: 12px 12px;
  scrollbar-width: none;
}

.sidebar-nav::-webkit-scrollbar {
  display: none;
}

.nav-section {
  margin-bottom: 4px;
}

.nav-section + .nav-section {
  margin-top: 8px;
}

.nav-section-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 8px 12px 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 10px;
  text-decoration: none;
  color: #475569;
  font-size: 13.5px;
  font-weight: 500;
  transition: all 0.15s ease;
  margin-bottom: 1px;
}

.nav-item:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.nav-item--active {
  background: #1A3A6B !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(26, 58, 107, 0.25);
}

.nav-item--active .nav-icon {
  color: rgba(255, 255, 255, 0.9) !important;
}

.nav-icon {
  color: #94a3b8;
  flex-shrink: 0;
  transition: color 0.15s;
}

.nav-item:hover .nav-icon {
  color: #475569;
}

.nav-label {
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* User Footer */
.sidebar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
}

.user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1A3A6B, #152E56);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.user-role {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.logout-btn {
  color: #94a3b8 !important;
  flex-shrink: 0;
}

.logout-btn:hover {
  color: #ef4444 !important;
  background: #fef2f2 !important;
}

/* ── Top Bar ── */
.topbar {
  box-shadow: none !important;
}

.topbar-menu-btn {
  color: #64748b !important;
}

.topbar-title {
  display: flex;
  align-items: center;
  gap: 4px;
}

.topbar-home-link {
  text-decoration: none;
  display: flex;
  align-items: center;
}

.topbar-page-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.topbar-switch {
  margin-right: 8px;
}

.topbar-avatar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
  margin-left: 4px;
}

.topbar-avatar:hover {
  background: #f1f5f9;
}

.topbar-avatar-circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1A3A6B, #152E56);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.topbar-avatar-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.topbar-user-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}

.topbar-user-role {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* Profile dropdown */
.profile-menu {
  padding: 4px 0 !important;
}

.profile-menu-header {
  padding: 12px 16px;
}

.profile-menu-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.profile-menu-email {
  font-size: 11px;
  color: #94a3b8;
  margin: 0;
}

.profile-menu-item {
  font-size: 13px !important;
  min-height: 38px !important;
}

.logout-item:hover {
  background: #fef2f2 !important;
}

/* Main content — matches HMS p-6 layout */
.main-content {
  background: #F1F5F9;
}
.main-content >>> .v-main__wrap {
  padding: 24px;
}
@media (max-width: 768px) {
  .main-content >>> .v-main__wrap {
    padding: 16px;
  }
}

/* Dialog */
.dialog-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #0f172a !important;
  padding-top: 20px !important;
}

/* Mobile responsive */
@media (max-width: 960px) {
  .topbar-title {
    display: none !important;
  }
}
</style>
